import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setItemInCart } from "./redux/cart/cartSlice";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

function FurnitureItem({ furniture }) {
  const dispatch = useDispatch();
  const { itemInCart } = useSelector((state) => state.cart);
  const [showAdded, setShowAdded] = useState(false);

  const addInCart = () => {
    const exists = itemInCart.some((item) => item.id === furniture.id);
    if (exists) {
      toast.info("Бул нерсе себетте мурунтан бар");
      return;
    }
    dispatch(setItemInCart(furniture));
    setShowAdded(true);
    setTimeout(() => setShowAdded(false), 1500);
  };

  return (
    <div className="bg-[#FAF9F6] rounded-[28px] overflow-hidden">
      {/* Image */}
      <Link to={`/${furniture.id}`}>
        <div className="relative">
          <img
            src={furniture.img}
            alt={furniture.title}
             loading="lazy"
    decoding="async"
    width="400"
    height="300"
    className="w-full h-full object-cover rounded-[28px]"
          />


        </div>
      </Link>

      {/* Content */}
      <div className="px-5 pt-4 pb-6">
        {/* Price */}
        <p className="text-sm font-medium text-gray-900 mb-1">
          {furniture.price} сом
        </p>

        {/* Title */}
        <Link to={`/${furniture.id}`}>
          <h3 className="text-xl font-semibold text-black leading-snug mb-2">
            {furniture.title}
          </h3>
        </Link>

        {/* Description */}
        <p className="text-gray-600 text-sm leading-relaxed mb-5">
          {furniture.description ||
            ""}
        </p>

        {/* Button */}
        <button
          onClick={addInCart}
          className="group relative overflow-hidden flex items-center justify-between
             bg-[#A1C349] hover:bg-[#beda76] transition
             text-white text-sm font-medium
             px-5 py-2.5 rounded-full w-[180px]"
        >
          <span className="absolute left-1 flex items-center justify-center w-8 h-8 bg-white text-black rounded-full transition-all duration-500 group-hover:left-[calc(100%-2.2rem)]">
            <ion-icon name="arrow-forward-outline"></ion-icon>
          </span>
          {/* Text */}
          <span
            className="absolute right-5 flex gap-[1px]
               transition-all duration-300
               group-hover:opacity-0 group-hover:-translate-x-4"
          >
            {"Сатып алуу".split("").map((char, i) => (
              <span key={i}> {char === " " ? "\u00A0" : char}</span>
            ))}
          </span>

          {/* Animated text (right side) */}
          <span
            className="flex gap-[1px] opacity-0
               group-hover:opacity-100
               group-hover:translate-x-0
               translate-x-4 transition-all duration-300"
          >
            {"Сатып алуу".split("").map((char, i) => (
              <span
                key={i}
                style={{ transitionDelay: `${i * 40}ms` }}
                className="inline-block transition-all duration-300
                   opacity-0 translate-y-2
                   group-hover:opacity-100 group-hover:translate-y-0"
              >
                 {char === " " ? "\u00A0" : char}
              </span>
            ))}
          </span>

          {/* Arrow */}
        </button>
        {showAdded && (
          <p className="mt-3 text-sm text-lime-600">
            ✔ Себетке кошулду
          </p>
        )}
      </div>
    </div>
  );
}

export default FurnitureItem;
